export const fetchPriceTypesSuccess = (priceTypeList) => ({
    type: 'FETCH_PRICE_TYPES_SUCCESS',
    payload: priceTypeList
});